import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import '@containers/Login/Login.css';

import { Footer } from '@components/Footer/Footer';
import LogoDark from '@components/Logo/Logo';
import { authApi } from '@reducers/auth';

export const Logout = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, isDuringLogout } = useSelector(
    (state) => state.auth
  );

  const [trigger, { isSuccess, isLoading }] = authApi.useLogoutMutation();
  useEffect(() => {
    if (!isAuthenticated || isSuccess) {
      navigate('/', { replace: true });
    }
    if (isAuthenticated && !isLoading && !isDuringLogout) {
      trigger({ login: user.login });
    }
  }, [isAuthenticated]);
  if (isLoading) {
    return (
      <>
        <div id="loginPage" className="login-body text-center">
          <div className="form-signin">
            <LogoDark href="/" className="login-logo" />
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return null;
};
